import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const ProductFilterBar = ({ onSearch, onFilter, onAddProduct }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [filters, setFilters] = useState({
    category: 'all',
    status: 'all'
  });

  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'HVAC', label: 'HVAC' },
    { value: 'Plumbing', label: 'Plumbing' },
    { value: 'Electrical', label: 'Electrical' },
    { value: 'Refrigeration', label: 'Refrigeration' },
    { value: 'Tools', label: 'Tools' },
    { value: 'Safety Equipment', label: 'Safety Equipment' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'In Stock', label: 'In Stock' },
    { value: 'Low Stock', label: 'Low Stock' },
    { value: 'Out of Stock', label: 'Out of Stock' }
  ];

  const handleSearchChange = (e) => {
    const value = e?.target?.value;
    setSearchQuery(value);
    onSearch(value);
  };

  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    onFilter(newFilters);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      category: 'all',
      status: 'all'
    };
    setFilters(clearedFilters);
    setSearchQuery('');
    onFilter(clearedFilters);
    onSearch('');
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-elevation-1 p-4 md:p-6 space-y-4">
      <div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3">
        <div className="flex-1">
          <div className="relative">
            <Icon
              name="Search"
              size={20}
              color="var(--color-muted-foreground)"
              className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
            />
            <input
              type="text"
              placeholder="Search by name, SKU, category, or supplier..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="w-full pl-10 pr-4 py-3 bg-background border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-smooth"
            />
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            iconName="Filter"
            iconPosition="left"
            onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
            className="flex-1 lg:flex-none"
          >
            Filters
          </Button>
          <Button
            variant="default"
            iconName="Plus"
            iconPosition="left"
            onClick={onAddProduct}
            className="flex-1 lg:flex-none"
          >
            Add Product
          </Button>
        </div>
      </div>

      {showAdvancedFilters && (
        <div className="pt-4 border-t border-border space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Select
              label="Category"
              options={categoryOptions}
              value={filters?.category}
              onChange={(value) => handleFilterChange('category', value)}
            />
            <Select
              label="Stock Status"
              options={statusOptions}
              value={filters?.status}
              onChange={(value) => handleFilterChange('status', value)}
            />
          </div>

          <div className="flex items-center justify-between">
            <div className="text-sm text-muted-foreground">
              {filters?.category !== 'all' || filters?.status !== 'all' ?'Active filters applied' :'No filters applied'}
            </div>
            <Button variant="ghost" size="sm" onClick={handleClearFilters}>
              Clear All Filters
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductFilterBar;